<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
  >
    <g id="noun_Pound_1411743" transform="translate(-10 -10)">
      <path
        id="Path_8706"
        data-name="Path 8706"
        d="M20.5,10A10.5,10.5,0,1,0,31,20.5,10.5,10.5,0,0,0,20.5,10Zm.136,7.379a1.487,1.487,0,0,0-1.357.882,2.205,2.205,0,0,0-.128.68h0a4.362,4.362,0,0,0,.248,1.426h2.075v1.3h-1.68a2.549,2.549,0,0,1-.191,1.951h3.822v1.3H17.575v-1.3H18.3a2.567,2.567,0,0,0,.191-1.951h-.92v-1.3H18.1a4.393,4.393,0,0,1-.248-1.415v-.086a2.789,2.789,0,1,1,5.576,0v.21H22.111a1.528,1.528,0,0,0,.015-.21,1.491,1.491,0,0,0-1.489-1.489Z"
        transform="translate(0)"
        class="svg-secondary"
      />
      <path
        id="Path_8707"
        data-name="Path 8707"
        d="M32.84,86.35a3.31,3.31,0,0,0,0,.58Z"
        transform="translate(-18.036 -60.668)"
        class="svg-secondary"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
